import axios from 'axios';
import {api} from '../constants/api';
import appConfig from '../../../config/common';
import {v4 as uuidv4} from 'uuid';

export const getInspectionData = ({
  accessToken,
  shumaID
}) => {
  const data = {shumaID: parseInt(shumaID, 10)};
  const config = {
    baseURL: appConfig.api.base_URL,
    headers: {
      accessToken,
      requestid: uuidv4(),
    },
  };
  return axios.post(api.GET_INSPECTION_DATA, data, config)
    .then(response => {
      return response.data.body
    })
};
